import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import {
  getPredMaintenanceStatusOptions,
  predMaintenanceStatusToTypeMap,
} from '../../../utils/textMappings';
import { PredMaintenanceStatusDropDownFilterCell } from './PredMaintenanceStatusDropDownFilterCell';
import { GetString } from '../../StringResourceManager';

export const PredictiveMaintenanceStatusFilterCell: any = (
  props: GridCustomFilterCellProps
) => (
  <PredMaintenanceStatusDropDownFilterCell
    {...props}
    data={getPredMaintenanceStatusOptions()}
    defaultItem={GetString('SELECT_STATUS')}
    onChangeValueCheckFunc={predMaintenanceStatusToTypeMap}
  />
);
